import classNames from 'classnames';
import 'communStyle.css';
import { useEffect, useRef } from 'react';
import { HiChevronDown } from 'react-icons/hi';
import { mapToCssModules } from '../utils';
import './styles.css';

function NavItem({ children, hasSubMenu, hideChevron, className, ...rest }) {
  return (
    <li className={`nav-item${hasSubMenu ? ' nav-item-has-sub-menu' : ''}${` ${className}` || ''}`} {...rest}>
      {children}
      {!hideChevron && hasSubMenu && (
        <div className="NavItem__icon-container">
          <HiChevronDown color="rgba(0,0,0,0.73)" size={15} />
        </div>
      )}
    </li>
  );
}
function NavItemMore({ children, ...rest }) {
  return (
    <NavItem id="NavItemMoreId" className="nav-item-more-hide" hasSubMenu hideChevron {...rest}>
      {children}
    </NavItem>
  );
}
function NavItemMoreSubMenu({ children, ...rest }) {
  return (
    <NavSubMenu {...rest}>
      <ul className="nav-item-more-sub-menu" id="NavItemMoreSubMenuId">
        {children}
      </ul>
    </NavSubMenu>
  );
}

function NavSubMenu(props) {
  const { className, cssModule, children, tag: Tag, ...attributes } = props;
  const NavSubMenuRef = useRef(null);
  useEffect(() => {
    if (NavSubMenuRef) {
      NavSubMenuRef.current.addEventListener(
        'mouseenter',
        (event) => {
          // on met l'accent sur la cible de mouseenter
          if (event.target.parentElement && event.target.parentElement.querySelector('.nav-link')) {
            event.target.parentElement.querySelector('.nav-link').classList.add('nav-link-hovered');
          }
        },
        false
      );
      NavSubMenuRef.current.addEventListener(
        'mouseleave',
        (event) => {
          // on met l'accent sur la cible de mouseenter
          if (event.target.parentElement && event.target.parentElement.querySelector('.nav-link')) {
            event.target.parentElement.querySelector('.nav-link').classList.remove('nav-link-hovered');
          }
        },
        false
      );
    }
    return () => {
      if (NavSubMenuRef) {
        NavSubMenuRef?.current?.removeEventListener(
          'mouseenter',
          (event) => {
            // on met l'accent sur la cible de mouseenter
            if (event.target.parentElement && event.target.parentElement.querySelector('.nav-link')) {
              event.target.parentElement.querySelector('.nav-link').classList.add('nav-link-hovered');
            }
          },
          false
        );
        // NavSubMenuRef?.current?.removeEventListener("mouseleave", function (event) {
        //     // on met l'accent sur la cible de mouseenter
        //     if (event.target.parentElement && event.target.parentElement.querySelector(".nav-link")) {
        //         event.target.parentElement.querySelector(".nav-link").classList.remove("nav-link-hovered")
        //     }
        // }, false);
      }
    };
  }, []);
  const classes = mapToCssModules(classNames(className, 'NavSubMenu__container'), cssModule);

  return (
    <Tag ref={NavSubMenuRef} className={classes} {...attributes}>
      {children}
    </Tag>
  );
}

NavSubMenu.defaultProps = {
  tag: 'div',
};

function NavSubMenuItem(props) {
  const { className, cssModule, children, tag: Tag, ...attributes } = props;

  const classes = mapToCssModules(classNames(className, 'NavSubMenu__item-container'), cssModule);

  return (
    <Tag className={classes} {...attributes}>
      <div className="NavSubMenu__item">{children}</div>
    </Tag>
  );
}

// NavSubMenuItem.propTypes = {
//   children: PropTypes.node,
//   tag: tagPropType,
//   className: PropTypes.string,
//   cssModule: PropTypes.object,
// };
NavSubMenuItem.defaultProps = {
  tag: 'div',
};

function NavSubMenuLink(props) {
  const { className, cssModule, children, tag: Tag, ...attributes } = props;

  const classes = mapToCssModules(classNames(className, 'NavSubMenu__link'), cssModule);

  return (
    <Tag {...attributes} className={classes}>
      {children}
    </Tag>
  );
}

// NavSubMenuLink.propTypes = {
//   children: PropTypes.node,
//   tag: tagPropType,
//   className: PropTypes.string,
//   cssModule: PropTypes.object,
// };
NavSubMenuLink.defaultProps = {
  tag: 'a',
};

export { NavItem, NavSubMenu, NavSubMenuItem, NavSubMenuLink, NavItemMore, NavItemMoreSubMenu };
